// src/components/organizer/layout/OrganizerSidebar.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Calendar, Settings, Menu, LogOut } from "lucide-react";
import { useDispatch } from "react-redux";
import { logoutOrganizer } from "@/store/slices/organizerSlice";
import { useNavigate } from "react-router-dom";

const OrganizerSidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const nav = [
    { label: "Dashboard", to: "/organizer/dashboard", icon: <Home className="w-5 h-5" /> },
    { label: "My Events", to: "/organizer/events", icon: <Calendar className="w-5 h-5" /> },
    { label: "Settings", to: "/organizer/settings", icon: <Settings className="w-5 h-5" /> },
  ];

  const isActive = (path) => {
    if (path === "/organizer/dashboard") {
      return location.pathname === "/organizer/dashboard" || location.pathname === "/organizer";
    }
    return location.pathname.startsWith(path);
  };

  const handleLogout = () => {
    dispatch(logoutOrganizer());
    navigate("/organizer/login");
  };

  return (
    <aside
      className={`flex flex-col bg-white dark:bg-gray-800 border-r border-gray-100 dark:border-gray-700 transition-all duration-200 ${
        collapsed ? "w-20" : "w-64"
      }`}
    >
      <div className="h-16 flex items-center px-4 border-b border-gray-100 dark:border-gray-700">
        <button
          onClick={() => setCollapsed((s) => !s)}
          className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        >
          <Menu className="w-5 h-5 text-gray-700 dark:text-gray-200" />
        </button>
        {!collapsed && (
          <div className="ml-3 font-semibold text-gray-800 dark:text-gray-100 flex items-center gap-2">
            <span className="bg-gradient-to-r from-amber-500 to-orange-500 bg-clip-text text-transparent">
              Organizer Portal
            </span>
          </div>
        )}
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {nav.map((item) => {
          const active = isActive(item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
                active
                  ? "bg-gradient-to-r from-amber-50 to-orange-50 text-amber-700 dark:from-amber-900/40 dark:to-orange-900/40 dark:text-amber-400 font-semibold"
                  : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
              }`}
            >
              <span className={`${active ? "text-amber-600 dark:text-amber-500" : "text-gray-500 dark:text-gray-400"}`}>
                {item.icon}
              </span>
              {!collapsed && <span className="font-medium">{item.label}</span>}
            </Link>
          );
        })}
      </nav>

      <div className="p-3 border-t border-gray-100 dark:border-gray-700">
        <button
          onClick={handleLogout}
          className={`flex items-center gap-3 px-3 py-2.5 rounded-lg w-full text-gray-600 dark:text-gray-300 hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-900/20 dark:hover:text-red-400 transition-colors ${
            collapsed ? "justify-center" : ""
          }`}
        >
          <LogOut className="w-5 h-5" />
          {!collapsed && <span className="font-medium">Logout</span>}
        </button>
      </div>
    </aside>
  );
};

export default OrganizerSidebar;
